module.exports = __webpack_public_path__ + "static/media/blacklogo.2a5ab9f6.svg";